import { jsx as l, jsxs as h } from "react/jsx-runtime";
import { c as g } from "./index-65016bfa.mjs";
import { forwardRef as B, useRef as j, useMemo as D, useImperativeHandle as Q } from "react";
import M, { css as u } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as v } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { AspectRatio as z } from "./aspectRatio.js";
import { MediaDisclosureButton as E } from "./mediaDisclosureButton.js";
import "./_commonjsHelpers-92157f1b.mjs";
const C = M.img`
  &.Image {
    ${({
  theme: {
    components: { image: e }
  }
}) => u(e.Image)};
    ${({ $style: e }) => u(e)};
  }
`, G = M.div`
  &.Image__content {
    ${({
  theme: {
    components: { image: e }
  }
}) => u(e.ImageContent)};
  }
`;
function J({
  srcProp: e,
  radii: w,
  src: t = e == null ? void 0 : e.url,
  alt: A = e == null ? void 0 : e.alt,
  disclosureLinks: m,
  width: f = "100%",
  height: i = "auto",
  minHeight: s,
  maxHeight: I,
  ratio: a,
  variant: o = "default",
  borderRadius: p = w,
  objectFit: r,
  objectPosition: c,
  className: $,
  children: y,
  ...N
}, S) {
  const _ = v({ label: "Image" }), R = j(null), n = j(null), d = typeof t == "object" ? t == null ? void 0 : t.url : t, x = typeof t == "object" ? t == null ? void 0 : t.alt : A, b = D(
    () => a == null ? void 0 : a.split(/[:/]/).map((q) => q.trim()).join("/"),
    [a]
  );
  return Q(
    S,
    () => ({
      ...n.current || {},
      get container() {
        return R.current;
      },
      get image() {
        return n.current;
      }
    }),
    []
  ), !m && !y ? /* @__PURE__ */ l(
    C,
    {
      ref: n,
      src: d,
      alt: x,
      $style: {
        width: f,
        height: i,
        minHeight: s,
        maxHeight: I,
        objectFit: r,
        objectPosition: c,
        borderRadius: p,
        aspectRatio: b
      },
      className: g(["Image", `Image--${o}`, $]),
      ...N,
      ..._
    }
  ) : /* @__PURE__ */ h(
    z,
    {
      ref: R,
      width: f,
      height: i,
      minHeight: s,
      maxHeight: I,
      borderRadius: p,
      variant: o,
      ratio: b,
      objectFit: r,
      objectPosition: c,
      className: "Image-wrapper",
      children: [
        /* @__PURE__ */ l(
          C,
          {
            ref: n,
            src: d,
            alt: x,
            $style: {
              width: "100%",
              height: "100%"
            },
            className: g(["Image", `Image--${o}`, $]),
            ...N,
            ..._
          }
        ),
        /* @__PURE__ */ h(G, { className: "Image__content", children: [
          y,
          m && /* @__PURE__ */ l(
            E,
            {
              ...m,
              className: g(["Image__disclosure-btn", m.className]),
              alignment: "bottom-right",
              containerPosition: { bottom: "8px", right: "24px" }
            }
          )
        ] })
      ]
    }
  );
}
const k = B(J);
export {
  k as Image
};
